
import React, { FC, useEffect, useState, useRef } from 'react';
import { Input, Modal } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';
import SPTableWithModel from '@/components/SPTableWithModel';
import { SPTableBaseMode } from '@/components/SPTableBase/effect';
import { debounce } from 'lodash';
import memo from '../memo';

interface CheckSameInputProps {
  API: {
    FetchAPI?: any;
  };
  field: any;
  value?: string;
  onChange?: Function;
  disabled?: boolean;
  allowClear?: boolean;
}

export const CheckSameInput: FC<CheckSameInputProps> = ({
  API,
  field,
  value,
  onChange,
  disabled,
  allowClear,
}) => {
  const { checkNamespace, checkModule, checkField, checkType = 'same', checkTableColumns } = field?.bizConfig || {};
  const [status, setStatus] = useState<any>('');
  const [visible, setVisible] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any[]>([]);

  const convert = (data: any) => {
    const obj: Record<any, any> = {};
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value;
    });
    return obj;
  };

  const searchData = (val: any): any => {
    if (!(val?.length > 0)) {
      setStatus('');
      return;
    }
    let filter = '';
    if (checkType === 'same') {
      filter = `${checkField} = '${val}'`;
    } else {
      filter = `${checkField} ILIKE '%${val}%'`;
    }
    const params: Record<any, any> = {
      moduleID: checkModule,
      namespaceID: checkNamespace,
      filter,
    };
    getModuleRecordListCache(API?.FetchAPI, checkNamespace, checkModule, params).then((res: any) => {
      const { set = [] } = res || {};
      if (set?.length > 0) {
        setStatus(checkType === 'same' ? 'error' : 'warning');
        const listData = set.map((r: any) => convert(r));
        setTableData(listData);
      } else {
        setStatus('');
        setTableData([]);
      }
    });
  };

  const setServicesValueDebounced = useRef(debounce(searchData, 500));

  const handleChange = (e: any) => {
    onChange?.(e.target.value);
    setServicesValueDebounced.current(e.target.value);
  };

  const getColumns = () => {
    const targetTableColumns =
      checkTableColumns?.map((item: any) => {
        const resColumn: Record<string, any> = {
          dataIndex: item,
          search: false,
        };
        return resColumn;
      }) || [];
    return targetTableColumns;
  };

  return (
    <>
      <Input value={value} status={status} disabled={disabled} onChange={handleChange} allowClear={allowClear !== false} />
      {
        status === 'error' ?
          <div style={{ color: '#ff4d4f', position: 'absolute' }}>{field.label}已存在</div> : ''
      }
      {
        status === 'warning' ?
          <>
            <div style={{ color: '#faad14', position: 'absolute' }}>相似度较高</div>
            <div
              style={{ color: '#faad14', position: 'absolute', right: 0, cursor: 'pointer' }}
              onClick={() => setVisible(true)}
            >
              查看
            </div>
          </> : ''
      }
      {visible &&
        <Modal
          zIndex={9999}
          visible
          onCancel={() => setVisible(false)}
          width={'70vw'}
          title="查重结果"
          okText="确认"
          cancelText="取消"
          onOk={() =>
            setVisible(false)
          }
        >
          <div style={{ height: '40px', background: '#FFFBE6', display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
            <InfoCircleOutlined style={{ color: '#faad14' }} />
            有{tableData?.length}条结果相似度较高
          </div>
          <SPTableWithModel
            value={tableData}
            API={API}
            moduleID={checkModule}
            search={false}
            namespaceID={checkNamespace}
            columns={getColumns()}
            tableBaseMode={SPTableBaseMode.VIEW}
          />
        </Modal>
      }
    </>
  );
};

export const CheckSameInputMemo = memo(CheckSameInput);
